import { useTranslation } from 'react-i18next';
import { LineText } from '@common/components/fragments/LineText';
import { ControlledSelect } from '@common/components/inputs/controlledInput/ControlledSelect';
import useLegalEntitiesSelectOptions from '@/modules/common/legalEntity/useLegalEntitiesSelectOptions';
import useLegalEntities from '@common/legalEntity/useLegalEntities';
import AuditsExportsRemindersExport from '@/app/spraypaint/audits/exports/AuditsExportsRemindersExport';
import {
  SubformComponent,
  SubCardFieldsComponent,
  SubModule,
} from '@/modules/admin/audits/components/submodules/types';

export const jsonApiType = AuditsExportsRemindersExport.jsonapiType;

export type Values = {
  legalEntityId: AuditsExportsRemindersExport['legalEntityId'];
};

export const defaultValues: Values = {
  legalEntityId: '1',
};

function createExportStrategy(data: Values): AuditsExportsRemindersExport {
  return new AuditsExportsRemindersExport({
    legalEntityId: data.legalEntityId,
  });
}

export const FormComponent: SubformComponent = ({ control }) => {
  const { t } = useTranslation();
  const legalEntityOptions = useLegalEntitiesSelectOptions();

  return (
    <ControlledSelect
      label={t('views.legal_entity.label')}
      className="mt-20"
      control={control}
      defaultValue={undefined}
      name="exportStrategy.params.legalEntityId"
      options={legalEntityOptions}
      required
    />
  );
};

export const CardFieldsComponent: SubCardFieldsComponent<
  AuditsExportsRemindersExport
> = ({ strategy: { legalEntityId } }) => {
  const { t } = useTranslation();
  const { legalEntities } = useLegalEntities();

  const legalEntity = (legalEntities || []).find(
    ({ id }) => String(id) === String(legalEntityId),
  );

  return (
    <>
      <LineText
        label={t('activerecord.attributes.audits/export.export_strategy', {
          ns: 'rails',
        })}
        value={t('activerecord.models.audits/exports/reminders_exports', {
          ns: 'rails',
        })}
      />
      <LineText
        label={t(
          'activerecord.attributes.audits/exports/reminders_export.legal_entity_id',
          {
            ns: 'rails',
          },
        )}
        value={legalEntity?.name}
      />
    </>
  );
};

export const AuditsExportsRemindersExportSubmodule: SubModule<
  Values,
  AuditsExportsRemindersExport
> = {
  jsonApiType,
  defaultValues,
  FormComponent,
  CardFieldsComponent,
  createExportStrategy,
};
